<script>
import Menu from 'ant-design-vue/es/menu';

export default {
  name: 'MMenuItemGroup',
  extends: Menu.ItemGroup
};
</script>
